import { useSelector } from 'react-redux';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { isSucceeded } from 'conversations-async-data/async-data/operators/statusComparators';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import getConnectedAccounts from '../../connected-accounts/selectors/getConnectedAccounts';
import DisconnectedEmailAccountBannerList from '../components/DisconnectedEmailAccountBannerList';
import ReconnectFBMPageBanner from '../components/ReconnectFBMPageBanner';
import { getFirstMessengerConnectionThatRequiresReAuth } from '../../messenger-connections/utils/getFirstMessengerConnectionThatRequiresReAuth';
import WhatsAppAccessRevokedBanner from '../components/WhatsAppAccessRevokedBanner';
import { getIsConversationsAdmin } from '../../selectors/userSelectors/getIsConversationsAdmin';
import { RefreshInboxBanner } from '../../refresh-inbox/components/RefreshInboxBanner';
import { useMessengerConnections } from '../../messenger-connections/hooks/useMessengerConnections';
import { TryHelpDeskBanner } from '../components/TryHelpDeskBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConnectedBanners = () => {
  const connectedEmailAccounts = useSelector(getConnectedAccounts);
  const currentInboxId = useSelector(getCurrentInboxId);
  const isConversationsAdmin = useSelector(getIsConversationsAdmin);
  const {
    asyncMessengerConnections
  } = useMessengerConnections();
  const firstMessengerConnectionThatRequiresReAuth = getFirstMessengerConnectionThatRequiresReAuth(getData(asyncMessengerConnections));
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(DisconnectedEmailAccountBannerList, {
      connectedEmailAccounts: connectedEmailAccounts,
      currentInboxId: currentInboxId || undefined,
      isConversationsAdmin: isConversationsAdmin
    }), isSucceeded(asyncMessengerConnections) && firstMessengerConnectionThatRequiresReAuth && /*#__PURE__*/_jsx(ReconnectFBMPageBanner, {
      messengerConnection: firstMessengerConnectionThatRequiresReAuth
    }), /*#__PURE__*/_jsx(RefreshInboxBanner, {}), /*#__PURE__*/_jsx(WhatsAppAccessRevokedBanner, {}), /*#__PURE__*/_jsx(TryHelpDeskBanner, {})]
  });
};
ConnectedBanners.displayName = 'ConnectedBanners';
export default ConnectedBanners;